import { ExpertAnketaHeader } from './ExpertAnketaHeader';

export default ExpertAnketaHeader;